export default {"src":"/_next/static/media/SPR.bd4dabbc.svg","height":18,"width":18};